import { render, staticRenderFns } from "./StudyNewPageTopicSelectorTopic.vue?vue&type=template&id=4c1d2972&scoped=true"
import script from "./StudyNewPageTopicSelectorTopic.vue?vue&type=script&lang=js"
export * from "./StudyNewPageTopicSelectorTopic.vue?vue&type=script&lang=js"
import style0 from "./StudyNewPageTopicSelectorTopic.vue?vue&type=style&index=0&id=4c1d2972&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1d2972",
  null
  
)

export default component.exports